import { createSelector } from 'reselect';

export const Types = {
  SEARCH_REQUEST: 'sections/SEARCH_REQUEST',
  SEARCH_SUCCESS: 'sections/SEARCH_SUCCESS',
  SEARCH_FAILURE: 'sections/SEARCH_FAILURE',
};

const initialState = {
  search: {
    data: [],
    loading: false,
  },
};

export default function reducers(state = initialState, action) {
  switch (action.type) {
    case Types.SEARCH_REQUEST:
      return {
        ...state,
        search: {
          ...state.search,
          loading: true,
        },
      };
    case Types.SEARCH_SUCCESS:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
          data: action.payload.sections.data,
        },
      };
    case Types.SEARCH_FAILURE:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  searchSectionsRequest: (query = '') => ({
    type: Types.SEARCH_REQUEST,
    payload: { query },
  }),

  searchSectionsSuccess: sections => ({
    type: Types.SEARCH_SUCCESS,
    payload: { sections },
  }),

  searchSectionsFailure: () => ({
    type: Types.SEARCH_FAILURE,
  }),
};

export const Selectors = {
  options: createSelector(
    state => state,
    sections => sections.map(section => ({ value: section.id, label: section.attributes.name })),
  ),
};
